var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside.includeChildrens",
          value: _vm.closeQrCode,
          expression: "closeQrCode",
          modifiers: { includeChildrens: true }
        }
      ],
      staticClass: "qrcode-popup"
    },
    [
      _c(
        "div",
        { staticClass: "btn-wrapper", on: { click: _vm.toggleQrCode } },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.qrcodeShow,
              expression: "qrcodeShow"
            }
          ],
          staticClass: "code-container"
        },
        [
          _c(
            "div",
            { staticClass: "code" },
            [
              _c("qrcode", {
                attrs: { text: _vm.qrcodeString, options: { size: 246 } },
                on: { genImage: _vm.getImage }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn __pointer", on: { click: _vm.downLoadQrCode } },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("saveQrcode")) + "\n        "
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }